import { render, staticRenderFns } from "./CreateAnnouncementType.vue?vue&type=template&id=21541cb3&scoped=true&"
import script from "./CreateAnnouncementType.vue?vue&type=script&lang=js&"
export * from "./CreateAnnouncementType.vue?vue&type=script&lang=js&"
import style0 from "./CreateAnnouncementType.vue?vue&type=style&index=0&id=21541cb3&lang=scss&scoped=true&"
import style1 from "./CreateAnnouncementType.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21541cb3",
  null
  
)

export default component.exports